function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.8878 13.0003L26.5053 2.77567C27.1649 2.14097 27.1649 1.11113 26.5053 0.476433C25.8456 -0.158811 24.7773 -0.158811 24.1177 0.476433L13.5003 10.701L2.8823 0.476433C2.22266 -0.158811 1.15438 -0.158811 0.494736 0.476433C-0.164912 1.11113 -0.164912 2.14097 0.494736 2.77567L11.1127 13.0003L0.494736 23.2249C-0.164912 23.8596 -0.164912 24.8894 0.494736 25.5241C0.824561 25.8412 1.25682 26 1.68852 26C2.12022 26 2.55248 25.8412 2.8823 25.5236L13.5003 15.299L24.1177 25.5236C24.4475 25.8412 24.8798 26 25.3115 26C25.7432 26 26.1754 25.8412 26.5053 25.5236C27.1649 24.8889 27.1649 23.859 26.5053 23.2243L15.8878 13.0003Z"
});

var SvgCancel = function SvgCancel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "white",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCancel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cancel.ab7f2372.svg";
export { ForwardRef as ReactComponent };